import { FlexBox, Table } from '@dixa/lib-shared-habla';

import { NotificationLayout } from 'components/notifications/components/notification/notificationLayout';

import { HistoricalNotification } from '../../notificationsPage.types';

type NotificationRowProps = {
  notification: HistoricalNotification;
  message?: JSX.Element | string;
  action?: JSX.Element;
  inlineEndAction?: JSX.Element;
};

export const NotificationRow = ({
  notification,
  message,
  action,
  inlineEndAction,
}: NotificationRowProps): JSX.Element => {
  return (
    <Table.Tr>
      <Table.Td>
        <NotificationLayout notification={notification.presentation} />
      </Table.Td>
      <Table.Td>{message}</Table.Td>
      <Table.Td width="0">
        <FlexBox justifyContent="flex-end">{action}</FlexBox>
      </Table.Td>
      <Table.Td width="0">{inlineEndAction}</Table.Td>
    </Table.Tr>
  );
};
